"use client";

import { createContext, useContext } from "react";

interface SiteContextType {
    siteId: string;
    isEditor?: boolean;
}

const SiteContext = createContext<SiteContextType | null>(null);

export const SiteProvider = ({ children, siteId, isEditor = false }: { children: React.ReactNode, siteId: string, isEditor?: boolean }) => {
    return (
        <SiteContext.Provider value={{ siteId, isEditor }}>
            {children}
        </SiteContext.Provider>
    );
};

export const useSite = () => {
    const context = useContext(SiteContext);
    if (!context) {
        // Fallback or throw? For safety in migration, return null or mock?
        // Better to throw if it's essential.
        // throw new Error("useSite must be used within a SiteProvider");
        return { siteId: null, isEditor: false };
    }
    return context;
};
